window.LOGIN = {
    layers: {
        phone_form: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item form.phone-form'),
        phone_form_input: $('#login-form-phone'),
        phone_form_submit: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item form.phone-form button'),
        phone_form_login_phone_error: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item form .phone-country-code-error'),
        tab_phone_layer: $('#login .login-content .tabs-layer .tabs-title-layer .tabs-title[data-key=phone]'),
        tab_code_layer: $('#login .login-content .tabs-layer .tabs-title-layer .tabs-title[data-key=code]'),
        tab_layer: $('#login .login-content .tabs-layer'),
        cross: $('#login .login-title .cross'),
        window: $('#login'),

        login_new_user_key: $('#login-new-user-key'),

        code_content: $('#login .login-content .tabs-content-layer-item.code'),

        login_code_password: $('#login-form-password'),
        login_btn: $('#login-form-btn'),
        login_form: $('#login-form'),
        map_login_btn: $('#login-map-btn'),
        forgot_password: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item .forgot-password button'),
        forgot_password_layer: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item .forgot-password'),

        map: {
            lang: $('#login .login-content .tabs-layer .tabs-content-layer .inner-tabs-content-layer .tabs-content-layer-item select')
        },

        one_password: {
            form: $('#login-form-one-password'),
            code: $('#login-form-one-code'),
            email: $('#login-form-email'),
            new_password: $('#login-form-one-code-password'),
            new_password_confirm: $('#login-form-one-code-password-confirm'),
            submit_btn: $('#login-form-one-password-btn')
        },

        new_account: {
            form: $('#login-form-new-password'),
            password: $('#login-form-new-password-input'),
            password_confirm: $('#login-form-new-password-confirm'),
            submit_btn: $('#login-form-new-password-btn')
        }
    },

    validatePhoneFormInput: function () {
        var phone = window.LOGIN.layers.phone_form_input.val();

        if(phone != '' && phone.length > 9) {
            if(parseInt(phone.substring(0, 1)) != 0) {
                window.LOGIN.layers.phone_form_submit.prop('disabled', false);

                if(!window.LOGIN.layers.phone_form_login_phone_error.hasClass('hide')) {
                    window.LOGIN.layers.phone_form_login_phone_error.addClass('hide');
                }

            } else {

                if(window.LOGIN.layers.phone_form_login_phone_error.hasClass('hide')) {
                    window.LOGIN.layers.phone_form_login_phone_error.removeClass('hide');
                }

                window.LOGIN.layers.phone_form_submit.prop('disabled', true);
            }
        } else {
            window.LOGIN.layers.phone_form_submit.prop('disabled', true);

            if(!window.LOGIN.layers.phone_form_login_phone_error.hasClass('hide')) {
                window.LOGIN.layers.phone_form_login_phone_error.addClass('hide');
            }
        }
    },

    validateLoginCodePassword: function () {
        var password = window.LOGIN.layers.phone_form_input.val();

        if(password.length > 5 && password.length < 21) {
            if(window.LOGIN.layers.login_btn.prop('disabled')) {
                window.LOGIN.layers.login_btn.prop('disabled', false);
            }
        } else {
            if(!window.LOGIN.layers.login_btn.prop('disabled')) {
                window.LOGIN.layers.login_btn.prop('disabled', true);
            }
        }
    },

    init: function () {
        window.LOGIN.layers.phone_form_input.on("keyup", function () {
            window.LOGIN.validatePhoneFormInput();
        });
        window.LOGIN.layers.phone_form_input.on("change", function () {
            window.LOGIN.validatePhoneFormInput();
        });

        window.LOGIN.layers.login_code_password.on("keyup", function () {
            window.LOGIN.validateLoginCodePassword();
        });
        window.LOGIN.layers.login_code_password.on("change", function () {
            window.LOGIN.validateLoginCodePassword();
        });

        window.LOGIN.layers.login_form.submit(function () {
            var password = window.LOGIN.layers.login_code_password.val();

            if(password.length > 5 && password.length < 21) {
                window.WS.login.loginPassword(window.LOGIN.layers.phone_form_input.val(), password);
            } else {
                window.LOGIN.layers.cross.click();
            }

            return false;
        });

        window.LOGIN.layers.one_password.form.submit(function () {
            window.WS.login_one_password(window.LOGIN.layers.one_password.email.val(), window.LOGIN.layers.phone_form_input.val());
            window.LOGIN.layers.one_password.submit_btn.prop('disabled', true);
            return false;
        });

        window.LOGIN.layers.new_account.form.submit(function () {
            var password = window.LOGIN.layers.new_account.password.val();
            var password_confirm = window.LOGIN.layers.new_account.password_confirm.val();
            var is_validate = true;

            if(password.length < 6 || password.length > 20) {
                is_validate = false;
            }
            if(password_confirm.length < 6 || password_confirm.length > 20) {
                is_validate = false;
            }
            if(password != password_confirm) {
                is_validate = false;
            }

            if(is_validate) {
                window.WS.login_new_account_password(window.LOGIN.layers.phone_form_input.val(), window.LOGIN.layers.login_new_user_key.val(), password, password_confirm);
            }

            window.LOGIN.layers.new_account.submit_btn.prop('disabled', true);

            return false;
        });


        window.LOGIN.layers.phone_form.submit(function () {
            var referral = $.cookie('referral');
            var utm_source = $.cookie('utm_source');

            if(typeof referral == 'undefined') {
                referral = '';
            }

            if(typeof utm_source == 'undefined') {
                utm_source = '';
            }

            window.WS.login.step1(window.LOGIN.layers.phone_form_input.val(), referral, utm_source);
            window.LOGIN.layers.phone_form_submit.prop('disabled', true);

            window.LOGIN.layers.phone_form_input.prop('readonly', true);
            window.LOGIN.layers.phone_form_input.attr('readonly', true);
            return false;
        });

        window.LOGIN.layers.cross.click(function () {
            if(window.LOGIN.layers.window.hasClass('active')) {
                window.LOGIN.layers.window.removeClass('active');
            }
            if(!window.LOGIN.layers.tab_phone_layer.hasClass('active')) {
                window.LOGIN.layers.tab_phone_layer.addClass('active');
            }
            if(window.LOGIN.layers.tab_code_layer.hasClass('active')) {
                window.LOGIN.layers.tab_code_layer.removeClass('active');
            }
            if(window.LOGIN.layers.tab_layer.hasClass('code')) {
                window.LOGIN.layers.tab_layer.removeClass('code');
            }

            window.LOGIN.layers.phone_form_input.prop('readonly', false);
            window.LOGIN.layers.phone_form_input.attr('readonly', false);
            window.LOGIN.layers.phone_form_submit.prop('disabled', true);
            window.LOGIN.layers.one_password.submit_btn.prop('disabled', true);

        });

        window.LOGIN.layers.map_login_btn.click(function () {
            if(!window.LOGIN.layers.window.hasClass('active')) {
                window.LOGIN.layers.window.addClass('active');
            }
        });

        window.LOGIN.layers.forgot_password.click(function () {
            window.WS.forgot_password(window.LOGIN.layers.phone_form_input.val());
            window.LOGIN.layers.forgot_password.prop('disabled', true);
        });

        window.LOGIN.layers.one_password.code.on("keyup", function () {
            window.LOGIN.onePasswordFormValidate();
        });
        window.LOGIN.layers.one_password.code.on("change", function () {
            window.LOGIN.onePasswordFormValidate();
        });
        window.LOGIN.layers.one_password.new_password.on("keyup", function () {
            window.LOGIN.onePasswordFormValidate();
        });
        window.LOGIN.layers.one_password.new_password.on("change", function () {
            window.LOGIN.onePasswordFormValidate();
        });
        window.LOGIN.layers.one_password.new_password_confirm.on("keyup", function () {
            window.LOGIN.onePasswordFormValidate();
        });
        window.LOGIN.layers.one_password.new_password_confirm.on("change", function () {
            window.LOGIN.onePasswordFormValidate();
        });

        window.LOGIN.layers.new_account.password.on("keyup", function () {
            window.LOGIN.newAccountPasswordFormValidate();
        });
        window.LOGIN.layers.new_account.password.on("change", function () {
            window.LOGIN.newAccountPasswordFormValidate();
        });
        window.LOGIN.layers.new_account.password_confirm.on("keyup", function () {
            window.LOGIN.newAccountPasswordFormValidate();
        });
        window.LOGIN.layers.new_account.password_confirm.on("change", function () {
            window.LOGIN.newAccountPasswordFormValidate();
        });
    },

    newAccountPasswordFormValidate: function () {
        var password = window.LOGIN.layers.new_account.password.val();
        var password_confirm = window.LOGIN.layers.new_account.password_confirm.val();
        var is_validate = true;

        if(password.length < 6 || password.length > 20) {
            is_validate = false;
        }
        if(password_confirm.length < 6 || password_confirm.length > 20) {
            is_validate = false;
        }
        if(password != password_confirm) {
            is_validate = false;
        }

        if(is_validate) {
            window.LOGIN.layers.new_account.submit_btn.prop('disabled', false);
        } else {
            window.LOGIN.layers.new_account.submit_btn.prop('disabled', true);
        }
    },

    onePasswordFormValidate: function () {
        var code = window.LOGIN.layers.one_password.code.val();
        var password = window.LOGIN.layers.one_password.new_password.val();
        var password_confirm = window.LOGIN.layers.one_password.new_password_confirm.val();
        var is_validate = true;

        if(password.length < 6 || password.length > 20) {
            is_validate = false;
        }
        if(password_confirm.length < 6 || password_confirm.length > 20) {
            is_validate = false;
        }
        if(code.length != 7) {
            is_validate = false;
        }
        if(password != password_confirm) {
            is_validate = false;
        }

        if(is_validate) {
            window.LOGIN.layers.one_password.submit_btn.prop('disabled', false);
        } else {
            window.LOGIN.layers.one_password.submit_btn.prop('disabled', true);
        }
    },

    openCodeform: function () {
        if(window.LOGIN.layers.tab_phone_layer.hasClass('active')) {
            window.LOGIN.layers.tab_phone_layer.removeClass('active');
        }
        if(!window.LOGIN.layers.tab_code_layer.hasClass('active')) {
            window.LOGIN.layers.tab_code_layer.addClass('active');
        }
        if(!window.LOGIN.layers.tab_layer.hasClass('code')) {
            window.LOGIN.layers.tab_layer.addClass('code');
        }
        if(window.LOGIN.layers.forgot_password_layer.hasClass('hide')) {
            window.LOGIN.layers.forgot_password_layer.removeClass('hide');
        }
        if(window.LOGIN.layers.forgot_password.prop('disabled')) {
            window.LOGIN.layers.forgot_password.prop('disabled', false);
        }
    },

    chargeAuthLang: function () {
        window.location.href = window.LOGIN.layers.map.lang.val();
    },

    showLoginForm: function () {
        window.LOGIN.layers.code_content.removeClass('login-form-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-one-password-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-new-password-layer-show');

        window.LOGIN.layers.code_content.addClass('login-form-layer-show');
    },

    showNewForm: function () {
        window.LOGIN.layers.code_content.removeClass('login-form-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-one-password-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-new-password-layer-show');

        window.LOGIN.layers.code_content.addClass('login-form-new-password-layer-show');
    },

    showOnePasswordForm: function () {
        window.LOGIN.layers.code_content.removeClass('login-form-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-one-password-layer-show');
        window.LOGIN.layers.code_content.removeClass('login-form-new-password-layer-show');

        window.LOGIN.layers.code_content.addClass('login-form-one-password-layer-show');
    }
};
window.LOGIN.init();
